export default function TrainingVideo({ video }) {
  if (!video) return null;

  const videoUrl = video.video_url; // Assuming full YouTube or direct link is stored

  return (
    <div>
      <h2>{video.title}</h2>
      <p>{video.description}</p>

      {/* Video Embed */}
      <div style={{ marginTop: '20px' }}>
        <iframe
          width="100%"
          height="500px"
          src={videoUrl}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Training Video"
        />
      </div>
    </div>
  );
}
